import Player from './player';
import './player.scss';

export default Player;